import React from 'react';

export interface StepError {
  step: number,
  element: string,
  message: string
}

export interface AddMeetingContextProps {
  activeStep: number,
  stepErrors: StepError[],
  setStepErrors: React.Dispatch<React.SetStateAction<StepError[]>>,
  errorsCount: number,
  formData: Record<string, any>
}

const AddMeetingContext = React.createContext<Partial<AddMeetingContextProps>>({
  activeStep: 0,
  stepErrors: [],
  setStepErrors: () => {},
  errorsCount: 0,
  formData: {}
});

export default AddMeetingContext;
